"use client"
import { ElProps } from "../type";
import React, { FC, createContext, useEffect, useState } from "react";
import Cookies from 'js-cookie'
import { Bugsnag } from "bugsnag";
import { useAccount } from "wagmi";

export interface GlobalContextProps {
  loggingIn?: boolean;
  updateLoggingIn?: (loggingIn: boolean) => void;
  initOsp?: ()=> Promise<void>
}

export const GlobalContext = createContext<Partial<GlobalContextProps>>({});

export interface GlobalProviderProps extends ElProps { };

export const GlobalProvider: FC<GlobalProviderProps> = (props) => {
  const {
    children
  } = props;
  const [loggingIn, setLoggingIn] = useState(false);
  const {chainId, address, isConnecting, isConnected, ...rest} = useAccount();
  useEffect(() => {
    initOsp();
  }, [])
  const initOsp = async () => {
    try {        
      let login_options = {}
      const jwt = Cookies.get('jwt_token')
      console.log("line32", jwt, isConnected);
      if(jwt){
        // setLoggingIn(true);
        if(isConnected){
          setLoggingIn(true);
        } else {
          setLoggingIn(false);
          Cookies.remove('jwt_token')
        }
      }
      console.log(login_options,'login_options')
    } catch (error) {
      Bugsnag.notify(`init osp error ${JSON.stringify(error)}`)
      console.log(error,'init osp error')
      Cookies.remove('jwt_token')
    }
  }
  return (
    <GlobalContext.Provider value={{
      loggingIn,
      updateLoggingIn: setLoggingIn,
      initOsp
    }}>
      {children}
    </GlobalContext.Provider>
  )
}

